import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserLookupComponent } from './user-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [UserLookupComponent],
  exports: [UserLookupComponent]
})
export class UserLookupModule { }
